export default __webpack_public_path__ + "static/media/arrow_blue.b6e43889.svg";